<template>
    <div  class="mpro wow">
     <div class="content">
         <div class="title">
             <p>service advantage</p>
             <p>服务优势</p>
             <p>延宝车管家   汽车质保专家</p>
         </div>
         <div class="allItems">
           <div class="item wow fadeInUp" v-for="(item,index) in list" :key="index">
                <div class="left">
                 <p>0{{index+1}}</p>
                    <p>{{item.title}}</p>
                    <p>{{item.entitle}}</p>
                </div>
               <div class="right">
                    <p>{{item.description}}</p>
               </div>
           </div>
         </div>
     </div>
    </div>
</template>

<script>
    import { getProductsUrl} from '../util/lang'
    export default {
        name: "mpro",
        data(){
          return{
              list:[]
          }
        },
        mounted(){
            this.$nextTick(()=>{
                this.getList('2')
            })
        },
        methods:{
            getList(id){
                const url = `${getProductsUrl(id)}`
                this.$axios.get(url).then(res => {
                    this.list=res.data.data
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.mpro{
    width:100%;
    background: url("../assets/ycb/sbg.png") no-repeat;
    padding: 60px 0;
    animation-duration: 3s;
    padding-bottom: 120px;
    animation: show 1s linear forwards;
    background-size: cover;
    .content{
        width:1440px;
        margin: 60px auto;
        .title{
            width:100%;
            p{
                text-align: center;
                color:white;
            }
            p:nth-child(1){
                font-family: "DINEngschriftStd";
                font-size: 40px;
                text-transform: uppercase;
            }
            p:nth-child(2){
                margin: 20px auto;
                font-family: "SourceHanSansSC-Normal.otf";
            }
            p:nth-child(3){
                font-size: 20px;
            }
        }
        .allItems{
            width:100%;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: space-between;
            margin: 30px auto;
            .item{
                width:49%;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                margin-top: 40px;
                .left{
                    width:30%;
                    background:rgba(255,255,255,.05);
                    border:1px solid rgba(255,255,255,.2);
                    padding: 10px 0;
                    p{
                        color:white;
                        width:90%;
                        margin-left: 5%;
                    }
                    p:nth-child(1){
                        font-size: 50px;
                        font-family: "DINEngschriftStd";
                        transition: all 600ms;
                    }
                    p:nth-child(2){
                        font-family: "SOURCEHANSANSCN-LIGHT";
                        font-size: 20px;
                        transition: all 600ms;
                    }
                    p:nth-child(3){
                        font-family: "it";
                        font-size: 14px;
                    }
                    &:hover{
                        p:nth-child(1){
                            transform: translateX(50px);
                            color:#F47238;
                        }
                        p:nth-child(2){
                            transform: translateX(20px);
                            color:#F47238;
                        }
                    }
                }
                .right{
                      width:67%;
                    background:rgba(255,255,255,.08);
                    border:1px solid rgba(255,255,255,.2);
                    padding: 15px 0;
                    p{
                        color:white;
                        width:90%;
                        margin-left: 5%;
                        font-size: 14px;
                        font-family: "SOURCEHANSANSCN-LIGHT";
                        line-height: 30px;
                    }
                }
            }
        }
    }
    @keyframes show {
        0% {
            filter:blur(10px);
        }
        100% {
            filter:blur(0);
        }
    }
    @media screen and (max-width: 1440px){
        .content{
            width:90%;
        }
    }
    @media screen and (max-width: 1000px){
        background-size: cover;
        padding-bottom: 60px;
        .content{
            width:90%;
            .allItems{
                .item{
                    width:100%;
                }
            }
        }
    }
}
</style>
